import { useState } from 'react';
import { Search, FileText, ExternalLink, Plus } from 'lucide-react';
import { useMfrs, mfrItems, searchMfr } from '../lib/mfr';
import useCatalog from '../hooks/useCatalog';
import { SECTORS } from '../lib/catalog';
import { eur } from '../lib/license';
import { MfrImg, openAsset } from '../lib/mfrAssets';

// one searchable list over all downloaded manufacturer catalogues + own catalogue
export default function MfrPicker({ t, onPick, onOwn, testid = 'mfr-picker', defSector }) {
  const mf = useMfrs();
  const { items, sector } = useCatalog();
  const [q, setQ] = useState('');
  const [src, setSrc] = useState('');
  const [sec, setSec] = useState(defSector || (SECTORS.includes(sector) ? sector : 'all'));
  const own = items.map((x) => ({ ...x, mfrId: '', mfr: t.rmCatOwn, mat: '', sector: x.sector || (x.id?.[0] === 'w' ? 'water' : '') }));
  const pool = src === 'own' ? own : src ? mfrItems(mf).filter((x) => x.mfrId === src) : [...mfrItems(mf), ...own];
  const list = searchMfr(pool, q, sec).slice(0, 150);
  return (
    <div className="mfr-picker" data-testid={testid}>
      <div className="row mfr-picker-bar">
        <label className="cat-search"><Search size={14} /><input autoFocus data-testid={`${testid}-search`} value={q} placeholder={t.mfSearch} onChange={(e) => setQ(e.target.value)} /></label>
        <select data-testid={`${testid}-source`} value={src} onChange={(e) => setSrc(e.target.value)}>
          <option value="">{t.rmAll}</option>
          {Object.values(mf).map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
          <option value="own">{t.rmCatOwn}</option>
        </select>
        <select data-testid={`${testid}-sector`} value={sec} onChange={(e) => setSec(e.target.value)}>
          {[...SECTORS, 'all'].map((s) => <option key={s} value={s}>{t['sec_' + s]}</option>)}
        </select>
      </div>
      <div className="mfr-list">
        {list.map((x) => (
          <div key={`${x.mfrId}-${x.id}`} className="mfr-item" data-testid={`${testid}-item-${x.id}`}>
            {x.img ? <MfrImg src={x.img} /> : <i className="fs-dot" style={{ background: x.color || '#64748b' }}>{x.sym || ''}</i>}
            <span className="mfr-item-txt"><b>{x.name}</b><small>{[x.mfr, x.dim, x.pn, x.mat, x.sku].filter(Boolean).join(' · ')}</small></span>
            <span className="mfr-item-price">{x.price != null ? eur(x.price, t.locale) : t.mfOnReq}</span>
            {x.pdf && <a className="icon-btn" href={x.pdf} onClick={(e) => openAsset(x.pdf, e)} target="_blank" rel="noreferrer" title={t.mfDatasheet} data-testid={`${testid}-pdf-${x.id}`}><FileText size={14} /></a>}
            {x.url && <a className="icon-btn" href={x.url} target="_blank" rel="noreferrer" title={t.mfWeb}><ExternalLink size={14} /></a>}
            <button className="btn btn-green btn-sm" data-testid={`${testid}-pick-${x.id}`} onClick={() => onPick(x)}><Plus size={14} /></button>
          </div>
        ))}
        {!list.length && (
          <div className="empty" data-testid={`${testid}-empty`}>{t.rmNoHit} {q && <button className="btn btn-outline btn-sm" data-testid={`${testid}-own`} onClick={() => onOwn(q)}>{t.rmTakeOwn}</button>}</div>
        )}
      </div>
    </div>
  );
}
